import type { Events, LoginWithActionEvent } from '@layers/web/constants/types/event.ts'

const events: Events = {
  // Modal toggles
  showHotelModalRooms: 'modal::open::hotel::rooms',
  closeHotelModalRooms: 'modal::close::hotel::rooms',
  openRolfDropdown: 'bv::dropdown::show',
  hideRolfDropdown: 'bv::dropdown::hide',
  showModal: 'bv::modal::show',
  hideModal: 'bv::modal::hide',
  showTranslationModal: 'modal::open::translation::single',
  showFullPageTranslationModal: 'modal::open::translation::page',

  // Localstorage reactivity
  setFavourites: 'localstorage::set::solresorFavourites',

  // Dealfinder
  dealfinderUpdateCalendarDate: 'dealfinder::calendar::update',
  dealfinderLoading: 'dealfinder::loading',

  // Misc
  packageSearchBarSearch: 'zz::search::package-bar',
  packageSearchFiltersReset: 'zz::filters::reset',
  nuxtIsLoading: 'nuxt::loading',
  pageIsReady: 'onreadystatechange',
  mapboxLoaded: 'mapbox::loaded',
  selectedAirport: 'airport::selected',

  // Cookie consent
  rbcsChange: 'consent::rbcs',

  calendarRefresh: 'calendar:refresh',
}

const loginWithActionEvent: LoginWithActionEvent = {
  toggleFavourite: 'toggleFavourite',
}

export default events

export { events, loginWithActionEvent }